
function carousel() {
    (function($) {
        var stories = $(".story");
        var numStories = stories.length;
        var prevLink = $(".fa-chevron-left");
        var nextLink = $(".fa-chevron-right");
        var selected = 0;
        
        function showSelected() {
            stories.each(function(i) {
                if (i === selected) {
                    $(this).addClass("selected");
                }
                else {
                    $(this).removeClass("selected");
                }
            });
        }

        function step(inc) {
            selected = (selected + inc) % numStories;
            if (selected < 0) {
                selected += numStories;
            }
            showSelected();
        }

        prevLink.click(function() {
            step(-1);
        });

        nextLink.click(function() {
            step(1);
        });

    })(jQuery);
}